import { pgTable, text, timestamp, integer, bigint, index, foreignKey, vector } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';
import { documentStatus } from './enums';
import { file } from './files';

export const knowledgeDocument = pgTable('KnowledgeDocument', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  filename: text().notNull(),
  mimeType: text().notNull(),
  fileSize: bigint({ mode: 'number' }).notNull(),
  filePath: text().notNull(),
  fileId: integer(),
  status: documentStatus().default('PENDING').notNull(),
  error: text(),
  chunksCount: integer().default(0).notNull(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'date' }).notNull(),
}, (table) => [
  index('KnowledgeDocument_status_idx').using('btree', table.status.asc().nullsLast()),
  foreignKey({
    columns: [table.fileId],
    foreignColumns: [file.id],
    name: 'KnowledgeDocument_fileId_fkey'
  }).onUpdate('cascade').onDelete('set null'),
]);

export const documentChunk = pgTable('DocumentChunk', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  documentId: integer().notNull(),
  content: text().notNull(),
  chunkIndex: integer().notNull(),
  pageNumber: integer(),
  startChar: integer(),
  endChar: integer(),
  embedding: vector({ dimensions: 312 }),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
}, (table) => [
  index('DocumentChunk_chunkIndex_idx').using('btree', table.chunkIndex.asc().nullsLast()),
  index('DocumentChunk_documentId_idx').using('btree', table.documentId.asc().nullsLast()),
  foreignKey({
    columns: [table.documentId],
    foreignColumns: [knowledgeDocument.id],
    name: 'DocumentChunk_documentId_fkey'
  }).onUpdate('cascade').onDelete('cascade'),
]);
